import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import Card from "./card.js";
var ClassicCard = /*#__PURE__*/function (_Card) {
  _inherits(ClassicCard, _Card);
  var _super = _createSuper(ClassicCard);
  function ClassicCard(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m) {
    var _this;
    _classCallCheck(this, ClassicCard);
    _this = _super.call(this, s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m), _this.Xt = "ab-classic-card", _this.Yt = !0;
    return _this;
  }
  _createClass(ClassicCard, [{
    key: "dt",
    value: function dt() {
      var s = {};
      return s[Card.ss.ts] = Card.es.ai, s[Card.ss.rs] = this.id, s[Card.ss.os] = this.viewed, s[Card.ss.cs] = this.title, s[Card.ss.ns] = this.imageUrl, s[Card.ss.ds] = this.description, s[Card.ss.ps] = this.updated, s[Card.ss.us] = this.expiresAt, s[Card.ss.URL] = this.url, s[Card.ss.ls] = this.linkText, s[Card.ss.fs] = this.aspectRatio, s[Card.ss.xs] = this.extras, s[Card.ss.bs] = this.pinned, s[Card.ss.gs] = this.dismissible, s[Card.ss.js] = this.clicked, s[Card.ss.zs] = this.language, s[Card.ss.ks] = this.altImageText, s[Card.ss.qs] = this.test, s;
    }
  }]);
  return ClassicCard;
}(Card);
export { ClassicCard as default };